/**
 * The JS file for the A/B testing functionality for footer donation in Grist.
 */
import { getCookie, setCookie } from './cookie-manager.js';
/**
 * Get or assign the A/B test variant for a given test
 * @param testName
 * @returns {string}
 */
function getABTestVariant(testName) {
  let variant = getCookie(`ab_testing_${testName}`); // Check if a variant is already set in cookie

  if (!variant) {
    // If not, assign randomly (50/50 split)
    variant = Math.random() < 0.5 ? 'footer_donation_old' : 'footer_donation_new';
    setCookie(`ab_testing_${testName}`, variant, 30); // Store for 30 days
  }
  return variant;
}

// Call this early on page load
const donationVariant = getABTestVariant('footer_donation_winter');
// You can make this global or pass it around
window.abTestFooterDonationVariant = donationVariant;
const viewportWidth = window.innerWidth;


// Push the variant as a user property to the dataLayer if the cookie exists.
// This will make it available for the GA4 Configuration Tag.
if (donationVariant) {
  window.dataLayer = window.dataLayer || [];
  // Push the variant as a user property to the dataLayer
  // This can be useful for debugging or if you want to explicitly count variant assignments.

  var donationVariantLabel = donationVariant === 'footer_donation_old' ? 'end-article-a' : 'end-article-b';
  window.dataLayer.push({
    'event': 'ab_test_footer_donation_variant_set',
    'footer_donation_ab_test_variant': donationVariantLabel // Parameter for this specific event
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const currentDonationVariant = window.abTestFooterDonationVariant; // Get the assigned variant

  // Hide all variants first (if not already hidden by default CSS).
  document.querySelectorAll('.membership-ad').forEach(el => {
    el.style.display = 'none';
  });

  // Apply special styling for the new variant.
  if ( 'footer_donation_new' === currentDonationVariant ) {
    document.querySelectorAll('.ad-article-footer')
      .forEach(el => el.classList.add('ad-article-footer-lavender'));
  } else {
    document.querySelectorAll('.ad-article-footer')
      .forEach(el => el.classList.remove('ad-article-footer-lavender'));
  }

  // Show the assigned variant.
  const activeDonationElement = document.getElementById(`membership_${currentDonationVariant}`);

  // Only show if the element exists (in case of misconfiguration).
  if (activeDonationElement) {
    activeDonationElement.style.display = 'block'; // Or 'flex', 'grid' etc. based on your CSS
  }
});
